import { type NotificationItemProps } from 'src/components/atomsLegacy/NotificationItem';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { EmptyState } from 'src/components/molecules/EmptyState';
import { useTranslation } from 'react-i18next';
import { NavbarVariantEnum } from 'src/types';
import {
  EmptyNotifications,
  EmptyReporterNotifications,
  EmptyReporterNotificationsState,
  EmptyReporterNotificationsTop,
} from './ActualNotifications.styles';

export const EmptyNotificationsComponent = ({
  variant = NavbarVariantEnum.MANAGER,
  handleMenuClose,
}: {
  variant?: NavbarVariantEnum;
  handleMenuClose: NotificationItemProps['handleMenuClose'];
}) => {
  const { t } = useTranslation();
  if (
    variant === NavbarVariantEnum.REPORTER ||
    variant === NavbarVariantEnum.PUBLIC
  ) {
    return (
      <EmptyReporterNotifications
        data-testid={'empty-reporter-notifications-container'}
      >
        <EmptyReporterNotificationsTop>
          <StyledIcon
            className={`uil uil-angle-left`}
            size="40px"
            onClick={handleMenuClose}
            isClickable={true}
          />
        </EmptyReporterNotificationsTop>
        <EmptyReporterNotificationsState>
          <EmptyState
            size="small"
            title={t('general.navbar.notificationsDrawer.emptyTitle')}
            description={t(
              'general.navbar.notificationsDrawer.emptyDescription',
            )}
            notificationEmptyState
          />
        </EmptyReporterNotificationsState>
      </EmptyReporterNotifications>
    );
  }

  return (
    <EmptyNotifications data-testid={'empty-notifications-container'}>
      <EmptyState
        size="small"
        title={t('general.navbar.notificationsDrawer.emptyTitle')}
        description={t('general.navbar.notificationsDrawer.emptyDescription')}
        notificationEmptyState
      />
    </EmptyNotifications>
  );
};
